export default __webpack_public_path__ + "static/media/mental_wellness.96b71349.svg";